import { render, staticRenderFns } from "./HumanFrontComponent.vue?vue&type=template&id=49b8ee70&scoped=true&"
import script from "./HumanFrontComponent.vue?vue&type=script&lang=js&"
export * from "./HumanFrontComponent.vue?vue&type=script&lang=js&"
import style0 from "./HumanFrontComponent.vue?vue&type=style&index=0&id=49b8ee70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b8ee70",
  null
  
)

export default component.exports